import { SPARKY_TSG_ACCESS_AVAIL_EXTPOINT, type ExtensionsConfig, type TsgAccessAvailConfig } from '../extpoints'
import { IP_RESTRICTED } from '../framework/constants'
import { stateRef } from '../framework/store'

export default {
  point: SPARKY_TSG_ACCESS_AVAIL_EXTPOINT,
  configs: [{
    id: 'sparky.tsg.access.avail.ip-restricted',
    config: {
      // isAllowed: () => Boolean(stateRef?.current?.auth?.instances),
      tsgAvail: () => {
        if (stateRef?.current?.auth?.instances?.error?.ipRestricted) {
          throw new Error(IP_RESTRICTED)
        }
        return true
      },
    }
  }]
} as ExtensionsConfig<TsgAccessAvailConfig>
